import {
  Alert,
  Button,
  LabIconsUploadIcon,
  XClearCircleIcon
} from '@customink/pigment-react';
import React, {useEffect, useState} from 'react';
import useBreakpoint from '../../hooks/useBreakpoint';
import UploadModal from './UploadModal';

function UploadBar({customDesignPreview, setCustomDesignPreview}) {
  const [displayModal, setDisplayModal] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(() =>
    Boolean(ProductCatalog.LocalStorage.read('custom_design_preview'))
  );
  const [recentUploads, setRecentUploads] = useState(
    () => ProductCatalog.LocalStorage.read('recent_design_uploads') || []
  );
  const isMobile = useBreakpoint() === 'md' || useBreakpoint() === 'sm';
  const fireMetricsEvent = (label) => {
    CustomInk.Metrics.pageViewTag(label);
  };

  const clearDesignPreview = () => {
    setCustomDesignPreview(null);
  };
  const handleAction = () => {
    if (fileUploaded) {
      fireMetricsEvent('catalog/upload/deleted');
      clearDesignPreview();
    } else {
      fireMetricsEvent('catalog/upload');
      setDisplayModal(true);
    }
  };

  useEffect(() => {
    ProductCatalog.LocalStorage.write(
      'recent_design_uploads',
      recentUploads || []
    );
  }, [recentUploads]);
  useEffect(() => {
    setFileUploaded(customDesignPreview !== null);
  }, [customDesignPreview]);

  return (
    <div className="pc-Styles-uploadBar">
      <Alert severity="info" icon={false}>
        <span
          className={`pc-Styles-uploadBar-text ${isMobile ? 'mobile' : 'full'}`}>
          <strong>
            {fileUploaded
              ? 'Design Uploaded! '
              : `Have a design${isMobile ? '' : ' or Logo'} ready? `}
          </strong>
          {fileUploaded
            ? 'Only you can see this preview.'
            : 'Upload it to preview on all products.'}
        </span>
        <Button
          startIcon={
            fileUploaded ? <XClearCircleIcon /> : <LabIconsUploadIcon />
          }
          variant="primary"
          size="medium"
          className="pc-Styles-uploadBar-action"
          onClick={() => {
            handleAction();
          }}>
          {fileUploaded ? 'Clear Design' : 'Upload Now'}
        </Button>
      </Alert>
      <UploadModal
        className="pc-Styles-uploadBar-modal"
        displayModal={displayModal}
        recentUploads={recentUploads}
        setDisplayModal={setDisplayModal}
        setCustomDesignPreview={setCustomDesignPreview}
        setRecentUploads={setRecentUploads}
        fireMetricsEvent={fireMetricsEvent}
      />
    </div>
  );
}

export default UploadBar;
